import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useLazyLoadQuery, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createVideoElementButton_createVideoElementMutation } from "@relay/createVideoElementButton_createVideoElementMutation.graphql";
import { createVideoElementButton_GetDefaultVimeoVideoSourceQuery } from "@relay/createVideoElementButton_GetDefaultVimeoVideoSourceQuery.graphql";
import {
	CREATE_VIDEO_ELEMENT_MUTATION,
	GET_DEFAULT_VIMEO_VIDEO_SOURCE_QUERY,
} from "./create-video-element-button.graphql";
import { CreateVideoElementButtonProps } from "./create-video-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateVideoElementButton = ({
	eLearningContentNodeId,
}: CreateVideoElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createVideoElement, isCreatingVideoElement] =
		useMutation<createVideoElementButton_createVideoElementMutation>(
			CREATE_VIDEO_ELEMENT_MUTATION,
		);
	const defaultVideoSourceData =
		useLazyLoadQuery<createVideoElementButton_GetDefaultVimeoVideoSourceQuery>(
			GET_DEFAULT_VIMEO_VIDEO_SOURCE_QUERY,
			{},
		);
	const defaultVideoSourceId =
		defaultVideoSourceData?.Admin?.VimeoVideoSource?.GetDefaultVimeoVideoSource?.id || "";

	const handleCreateOnClick = () => {
		createVideoElement({
			variables: {
				input: {
					title: t("educationalOffer.newElement"),
					vimeoId: "",
					vimeoVideoSourceId: defaultVideoSourceId,
					eLearningContentNodeId,
				},
			},
			updater: setDraft,
		});
	};

	return (
		<Button
			disabled={isCreatingVideoElement}
			tooltip={t("educationalOffer.createVideoElementTooltip")}
			icon={EpicIcons.VIDEO}
			onClick={handleCreateOnClick}
		/>
	);
};
